import { create } from "zustand";

type ChatThread = {
  id: string;
  title: string;
  description: string | null;
  workflowId: bigint | null;
  lastUpdatedAt: string;
  isTryMode?: boolean;
};

type SessionsState = {
  chats: ChatThread[];
  isLoadingChats: boolean;
  chatsError: string | null;
};

type SessionsStore = SessionsState & {
  updateSessionsStore: (
    partial:
      | Partial<SessionsState>
      | ((prev: SessionsState) => Partial<SessionsState>),
  ) => void;
};

export const useSessionsStore = create<SessionsStore>()((set) => ({
  chats: [],
  isLoadingChats: false,
  chatsError: null,
  updateSessionsStore: (partial) =>
    set((state) => {
      const prev: SessionsState = {
        chats: state.chats,
        isLoadingChats: state.isLoadingChats,
        chatsError: state.chatsError,
      };
      const patch = typeof partial === "function" ? partial(prev) : partial;
      return { ...patch };
    }),
}));

export type { SessionsState, SessionsStore, ChatThread };
